import { render } from "./BaseInput.vue?vue&type=template&id=cabd0844&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=cabd0844&scoped=true&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\vue-form\\vue-form\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cabd0844"]])

export default __exports__